import { MapPin } from "lucide-react";

const LINKS = [
  { id: "capabilities", label: "Capabilities" },
  { id: "applications", label: "Applications" },
  { id: "quality", label: "Quality" },
  { id: "about", label: "Facilities" },
  { id: "contact", label: "Contact" },
];

// P — Footer.
export const Footer = () => {
  const go = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="on-dark bg-[#05070b] pb-32 pt-16 text-white sm:pb-28">
      <div className="wrap">
        <div className="grid gap-12 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <div className="inline-flex rounded-lg bg-[#fafaf7] px-4 py-2.5">
              <img src="/pmp-logo.jpg" alt="Precision Machined Products" className="h-8 w-auto" />
            </div>
            <p className="mt-5 text-[15px] font-medium text-white/90">Precision Machined Products</p>
            <p className="font-serif-i mt-1 text-[15px] text-white/60">Precision for the details your design depends on.</p>
          </div>
          <div className="space-y-5">
            <p className="eyebrow !text-white/50"><span className="rule" />COLORADO</p>
            <p className="flex items-start gap-2.5 text-[14.5px] leading-relaxed text-white/80">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#9db8ff]" />
              1017 Smithfield Dr.<br />Fort Collins, CO 80524
            </p>
            <p className="eyebrow !text-white/50"><span className="rule" />WYOMING</p>
            <p className="flex items-start gap-2.5 text-[14.5px] leading-relaxed text-white/80">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#9db8ff]" />
              331 33rd Street<br />Cody, WY 82414
            </p>
          </div>
          <div>
            <p className="eyebrow !text-white/50"><span className="rule" />PHONE</p>
            <a href="tel:+19704827676" data-testid="footer-phone" className="mt-5 block text-[15px] font-medium text-white hover:text-[#9db8ff]">
              (970) 482-7676
            </a>
            <p className="eyebrow mt-7 !text-white/50"><span className="rule" />EXPLORE</p>
            <nav className="mt-4 flex flex-col gap-2" aria-label="Footer">
              {LINKS.map((l) => (
                <a key={l.id} href={`#${l.id}`} onClick={go(l.id)} data-testid={`footer-link-${l.id}`} className="text-[14.5px] text-white/75 transition-colors hover:text-white">
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
        <div className="mt-14 border-t border-white/10 pt-7">
          <p className="font-mono text-[11px] tracking-[0.08em] text-white/45">
            © {new Date().getFullYear()} Precision Machined Products, LLC
          </p>
        </div>
      </div>
    </footer>
  );
};
